const store = {
    namespaced: true,
    state: {
        isRecording: false,
    },
    mutations: {
        SET_RECORDING: (state, payload) => {
            state.isRecording = payload;
        },
    },
    actions: {},
};

export default store;



// WEBPACK FOOTER //
// ./src/store/modules/voiceRecorder.js